<template>
    <Dialog
        @close="$emit('close')">
        <template slot="header">{{ heading }}</template>
        <template slot="body">
            <LoadingOverlay
                v-if="loadingOverlay"
                :indefinite="true"/>
            <ul class="users"
                v-else>
                <li class="user"
                    v-for="(user, index) in users"
                    :key="index">
                    <Contributor
                        :slug="user.slug"
                        :avatar="user.avatar"
                        :name="user.name"/>
                </li>
            </ul>
            <Button class="loadButton"
                v-if="loaded < userIDs.length"
                appearance="secondary"
                size="fullWidth"
                @click="loadMore()">
                {{ siteContent.loadMore }}
            </Button>
        </template>
        <template slot="secondary">
            {{ siteContent.close }}
        </template>
    </Dialog>
</template>

<script>
    import { db } from '@/firebase'

    import Contributor from '@/components/entry/Contributor'

    export default {
        name: 'UserList',
        components: {
            Contributor
        },
        props: {
            heading: {
                type: String,
                required: true
            },
            userIDs: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                loadingOverlay: true,
                users: [],
                loaded: 0,
                batches: 0,
                batchSize: 5
            }
        },
        computed: {
            inititalLength() {
                if(this.userIDs.length < this.batchSize) {
                    return this.userIDs.length
                } else {
                    return this.batchSize
                }
            }
        },
        mounted() {
            this.initialLoad()
        },
        methods: {
            initialLoad() {
                for(let i = 0; i < this.inititalLength; i++) {
                    this.fetchUser(this.userIDs[i])
                    this.loaded++
                }
                this.batches++
                this.loadingOverlay = false
            },
            async fetchUser(id) {
                try {
                    let userRef = await db
                        .collection('users')
                        .doc(id)
                        .get()

                    this.users.push(userRef.data())
                }
                catch (error) {
                    throw error
                }
            },
            loadMore() {
                var nextElement = this.loaded
                if(this.userIDs.length > this.loaded + this.batchSize) {
                    var limit = this.loaded + this.batchSize
                } else {
                    var limit = this.userIDs.length
                }
                

                for(let j = nextElement; j < limit; j++) {
                    this.fetchUser(this.userIDs[j])
                    this.loaded++
                }
            }
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                this.$emit('close')
            }
        }
    }
</script>

<style lang="scss" scoped>

    .users {
        margin: 0;
        padding: 0;
    }

    .user {
        padding: 0;
        list-style: none;
    }

    .loadButton {
        margin-top: 1rem;
    }
</style>